module.exports = __webpack_public_path__ + "img/location.5ec2abd2.svg";